import React, { useEffect, useState } from 'react';
import './RosterPaymentsPage.css';

export default function RosterPaymentsPage() {
  const [players, setPlayers] = useState([]);

  const backendBase =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    (window.location.hostname === 'localhost'
      ? 'http://localhost:5001'
      : 'https://pickem-backend-2025.onrender.com');

  useEffect(() => {
    fetch(`${backendBase}/data/roster.json`, { cache: 'no-store' })
      .then((res) => res.json())
      .then((data) => setPlayers(Array.isArray(data) ? data : []))
      .catch(() => setPlayers([]));
  }, [backendBase]);

  const getPaymentStatus = (balance) => {
    if (balance >= 130) return '✅ Fully Paid';
    if (balance > 0)   return '🟡 Partially Paid';
    return '❌ No Payment';
  };

  return (
    <div className="roster-page">
      <h1 className="roster-title">Shama-Lama Football Challenge 2026 Roster</h1>
      <h3 className="roster-subtitle">Here are all the players for this year's challenge</h3>

      <div className="roster-list">
        {players.map((p, i) => (
          <div className="player-card" key={i}>
            <span className="player-name">🧢 {p.name}</span>
            <div className="icons">
              <span>🏈 👕</span>
              <span className="payment-status">{getPaymentStatus(Number(p.Balance || 0))}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

